import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import CursorTrail from '../CursorTrail/CursorTrail';
// A Choice field is serialized as {token, title}; a plain string stays a string.
const term = (value) => (value && value.title) || value;
const TalkView = (props) => {
  const { content } = props;
  const cursorTrailEnabled = content.cursor_trail_enabled === true;

  return (
    <div className="ui container view-wrapper talk-view">
      <CursorTrail enabled={cursorTrailEnabled} />
      <h1 className="documentFirstHeading">{content.title}</h1>
      {content.description && (
        <p className="documentDescription">{content.description}</p>
      )}

      <dl className="talk-metadata">
        <dt>Speaker</dt>
        <dd>
          {content.speaker}
          {content.company ? ` — ${content.company}` : ''}
        </dd>
        <dt>Type of talk</dt>
        <dd>{term(content.type_of_talk)}</dd>
        {content.audience?.length > 0 && (
          <>
            <dt>Audience</dt>
            <dd>{content.audience.map(term).join(', ')}</dd>
          </>
        )}
      </dl>
      {content.details && <p className="talk-details">{content.details}</p>}
      <RenderBlocks {...props} />
    </div>
  );
};
export default TalkView;
